import { parseAsJson } from 'nuqs';

export const runFiltersParser = parseAsJson<Record<string, unknown>>(value =>
  typeof value === 'string' ? JSON.parse(value) : value
);
